import ChampionshipApplication from '@/apps/ChampionshipApplication'
import Layout from '@/apps/layout/components'
import React from 'react'

const ChampionshipApplicationPage = (): React.ReactElement => {
  return (
    <Layout>
      <ChampionshipApplication />
    </Layout>
  )
}

export default ChampionshipApplicationPage
